import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";

export const TextB = (key, text) => <Typography key={key} noWrap>{text}</Typography>;
export const LinkB = (key, text, link) => <Link underline="hover" key={key} to={link}>{text}</Link>;
